// src/core/config/index.ts
// ⚠️ 모든 클라이언트 설정 상수를 정의합니다.

import serverApiConfig from "../../../config/serverApi.json"

export interface ServerUrls {
  API_BASE_URL: string | null
  WS_BASE_URL: string | null
}

export const SERVER_PORT = 57443
export const SERVER_API_DEV = serverApiConfig.serverApi.dev
export const SERVER_API_PROD = serverApiConfig.serverApi.prod
export const SERVER_API2_DEV = serverApiConfig.serverApi2.dev
export const SERVER_API2_PROD = serverApiConfig.serverApi2.prod
export const SERVER_API3_DEV = serverApiConfig.serverApi3.dev
export const SERVER_API3_PROD = serverApiConfig.serverApi3.prod
export const SERVER_API3_PUBLIC_KEY = serverApiConfig.serverApi3.publicApiKey

/** 프로덕션 빌드 여부 (Vite: import.meta.env.PROD) */
export const IS_PRODUCTION = import.meta.env.PROD

const safeGetLocalStorage = (key: string): string | null => {
  if (typeof window === "undefined" || !window?.localStorage) {
    return null
  }

  try {
    return window.localStorage.getItem(key)
  } catch (error) {
    console.warn("로컬 스토리지 접근 실패:", error)
    return null
  }
}

export const getServerUrls = (): ServerUrls => {
  const serverHost = safeGetLocalStorage("SigmaServerIp")

  if (!serverHost) {
    return {
      API_BASE_URL: null,
      WS_BASE_URL: null,
    }
  }

  return {
    API_BASE_URL: `https://${serverHost}:${SERVER_PORT}`,
    WS_BASE_URL: `wss://${serverHost}:${SERVER_PORT}`,
  }
}

const initialUrls = getServerUrls()

export let API_BASE_URL = initialUrls.API_BASE_URL
export let WS_BASE_URL = initialUrls.WS_BASE_URL

export const updateServerUrls = (): ServerUrls => {
  const urls = getServerUrls()
  API_BASE_URL = urls.API_BASE_URL
  WS_BASE_URL = urls.WS_BASE_URL
  return urls
}
export const IMAGE_BASE_URL = "/images"
export const CONFIRM_KEY = "U01TX0FVVEgyMDI1MDYxNjA5NTYxMTExNTg0NTc="
export const RETRY_COUNT = 10
